module.exports = __webpack_public_path__ + "img/quick_settings.9ced8264.png";